module.exports = __webpack_public_path__ + "img/main.b4a76e2b.jpg";